export function commafy(num) {
  var numAsStr = num.toString()
  var numComponents = numAsStr.split(".")
  var integerComponent = numComponents[0]
  var decimalComponent = numComponents[1] ? numComponents[1] : "00"
  while (decimalComponent.length < 2) {
    decimalComponent = decimalComponent + "0"
  }
  
  if (integerComponent.length >= 4) {
    integerComponent = integerComponent.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
  }
  return [integerComponent, decimalComponent].join(".");
}
function getValueFromOptions(options, key, defaultValue) {
// helper function to allow empty value in toPrice
  var ret = options[key]
  if (ret === undefined) {
    return defaultValue
  }
  return ret;
}
export function toPrice(num, options={}) {
  var defaultPrice = options.defaultPrice ? options.defaultPrice : undefined
  var negPrefix = getValueFromOptions(options, 'negPrefix', '(')
  var negSuffix = getValueFromOptions(options, 'negSuffix', ')')
  var posPrefix = getValueFromOptions(options, 'posPrefix', '')
  var currencySymbol = getValueFromOptions(options, 'currencySymbol', '$')

  if (typeof(num) === "string") {
    num = num.replaceAll(',','')
  }
  var numAsNum = parseFloat(num).toFixed(2)
  if (isNaN(numAsNum)) {
    if (defaultPrice === undefined) {
      numAsNum = 0
    } else {
      return defaultPrice
    }
  }
  
  if (numAsNum < 0) {
    return `${negPrefix}${currencySymbol}${commafy(-numAsNum)}${negSuffix}`
  }
  return `${posPrefix}${currencySymbol}${commafy(numAsNum)}`
}

export function amountStrtoFloat(text){
  var num = 0;
  if (!text) {
    return num;
  }
  text = text.replaceAll('$','').replaceAll(' ', '').replaceAll(',', '');
  if(text[0] === "-"){
    num = -1 * parseFloat((text).slice(1));
  }else{
    num = parseFloat(text);
  }
  return num;
}

export function capitalize(str) {
  if(str.length === 0) return str;
  return str[0].toUpperCase() + str.substr(1);
}

export function titleCase(str) {
  if(str === undefined || str.length === 0) return str;
  return str.split(' ').map(capitalize).join(' ');
}